export default "__VITE_ASSET__v$TMALD$__"